import { styled } from '@mui/material/styles';
import { List, ListItem, Divider as MuiDivider } from '@mui/material';

export const AutocompleteDropdown = styled('div')<{ open: boolean }>(({ theme, open }) => ({
  boxSizing: 'border-box',
  display: open ? 'flex' : 'none',
  flexDirection: 'column',
  gap: '4px',
  backgroundColor: theme.palette.grey[500],
  width: '248px',
  maxHeight: '520px',
  alignItems: 'center',
  borderRadius: '8px',
  position: 'absolute',
  top: '100%',
  zIndex: 1,
  boxShadow: theme.customShadows.z8,
  padding: theme.spacing(2)
}));

export const InputContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[600],
  borderRadius: '6px',
  padding: theme.spacing(1),
  gap: '10px',
  width: '100%'
}));

export const Input = styled('input')(({ theme }) => ({
  background: 'transparent',
  border: 'none',
  outline: 'none',
  color: theme.palette.grey[200],
  fontSize: '14px',
  width: '80%',
  '&::placeholder': {
    color: theme.palette.grey[200]
  }
}));

export const Divider = styled(MuiDivider)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2)
}));

export const DropdownList = styled(List)(({ theme }) => ({
  overflow: 'auto',
  width: '100%'
}));

export const AutocompleteItem = styled(ListItem)<{ active: boolean }>(({ active, theme }) => ({
  padding: theme.spacing(1),
  borderRadius: 6,
  overflow: 'hidden',
  cursor: active ? 'default' : 'pointer',
  backgroundColor: active ? theme.palette.grey[300] : '',
  '&:hover': { backgroundColor: theme.palette.grey[300] }
}));
